export const ownershipFilterOptions = [
  { filter: null, label: { id: 'all', defaultMessage: 'All' } },
  {
    filter: true,
    label: {
      id: 'owned',
      defaultMessage: 'Owned',
    },
  },
  {
    filter: false,
    label: {
      id: 'not-owned',
      defaultMessage: 'Not Owned',
    },
  },
];
